(() => {
  if (window.GoyojoFirmwareCenter) {
    window.GoyojoFirmwareCenter.initAll();
    return;
  }

  const normalize = (value) => (value || '').toLocaleLowerCase().trim();

  const initSection = (section) => {
    if (!section || section.dataset.firmwareCenterInitialized === 'true') return;
    section.dataset.firmwareCenterInitialized = 'true';

    const cards = Array.from(section.querySelectorAll('[data-fc-card]'));
    const searchInput = section.querySelector('[data-fc-search]');
    const categoryButtons = Array.from(section.querySelectorAll('[data-fc-category]'));
    const resetButton = section.querySelector('[data-fc-reset]');
    const emptyState = section.querySelector('[data-fc-empty]');

    let activeCategory = 'all';
    let searchQuery = '';

    const setActiveCategory = (category) => {
      activeCategory = category || 'all';
      categoryButtons.forEach((button) => {
        const isActive = button.dataset.fcCategory === activeCategory;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    };

    const applyFilters = () => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const categoryMatch = activeCategory === 'all' || card.dataset.category === activeCategory;
        const searchMatch = !searchQuery || normalize(card.dataset.search).includes(searchQuery);
        const isVisible = categoryMatch && searchMatch;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (emptyState && cards.length > 0) emptyState.hidden = visibleCount !== 0;
    };

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchQuery = normalize(searchInput.value);
        applyFilters();
      });
    }

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setActiveCategory(button.dataset.fcCategory);
        applyFilters();
      });
    });

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        searchQuery = '';
        if (searchInput) searchInput.value = '';
        setActiveCategory('all');
        applyFilters();
        searchInput?.focus();
      });
    }

    section.querySelectorAll('[data-fc-accordion]').forEach((button) => {
      button.addEventListener('click', () => {
        const panelId = button.getAttribute('aria-controls');
        const panel = panelId ? section.querySelector(`[id="${panelId}"]`) : null;
        if (!panel) return;

        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        panel.setAttribute('aria-hidden', String(isOpen));
        panel.classList.toggle('is-open', !isOpen);

        const label = button.querySelector('[data-fc-accordion-label]');
        if (label) label.textContent = isOpen ? 'View release notes' : 'Hide release notes';
      });
    });

    applyFilters();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-firmware-center]')) initSection(scope);
    scope.querySelectorAll?.('[data-firmware-center]').forEach(initSection);
  };

  window.GoyojoFirmwareCenter = { initAll, initSection };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

